/**
 * @file src/components/molecules/Charts/StyledPieChart.tsx
 * @description This file defines a flexible StyledPieChart component using Recharts.
 * @module StyledPieChart
 */

import React, { FC } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface StyledPieChartProps {
  data: { name: string; value: number }[];
  colors?: string[];
  size?: number;
  strokeColor?: string;
  strokeWidth?: number;
}

const StyledPieChart: FC<StyledPieChartProps> = ({
  data,
  colors = ['#C4FAC3', '#FFFFFF1A'],
  size = 200,
  strokeColor = '#FFFFFF26',
  strokeWidth = 1,
}) => {
  const outerRadius = size / 2 - strokeWidth;

  return (
    <div className="w-full flex justify-center">
      <div style={{ width: size, height: size, position: 'relative' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              cx="50%"
              cy="50%"
              outerRadius={outerRadius}
              stroke={strokeColor}
              strokeWidth={strokeWidth}
              isAnimationActive={true}
              animationBegin={0}
              animationDuration={800}
              animationEasing="ease-out"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StyledPieChart;
